<template>
  <loading v-if="loadingStatus === 'LOADING'" />
  <div
    v-else
    class="account-tab"
  >
    <div
      v-if="memberData"
      class="account-tab__box-wrapper"
    >
      <div class="account-tab__content-wrapper">
        <span>Nome</span>
        <p>{{ memberData.name }}</p>
      </div>
      <div class="account-tab__content-wrapper">
        <span>E-mail</span>
        <p>{{ memberData.username }}</p>
      </div>
      <div class="account-tab__content-wrapper">
        <span>CPF</span>
        <p>{{ memberData.cpf }}</p>
      </div>
      <div class="account-tab__content-wrapper">
        <span>Data de nascimento</span>
        <p>{{ formatDate(memberData.birthday) }}</p>
      </div>
      <div class="account-tab__content-wrapper">
        <span>Telefone</span>
        <p>{{ memberData.phone }}</p>
      </div>
    </div>
    <div
      v-else
      class="account-tab__content-wrapper-error"
    >
      <p>Não foi possível carregar os dados da conta</p>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Moment from 'moment'

import UserManagementModal from '@/components/ProfileManagement/components/UserManagementModal.vue'
import UserManagementEditModal from '@/components/ProfileManagement/components/UserManagementEditModal.vue'
import DisableUserModal from '@/components/ProfileManagement/components/DisableUserModal.vue'
import FirstAccessModal from '@/components/ProfileManagement/components/FirstAccessModal.vue'

export default {
  name: 'ProfileManagementView',
  components: {
    UserManagementModal,
    UserManagementEditModal,
    DisableUserModal,
    FirstAccessModal
  },
  data() {
    return {
      memberData: {
        name: '',
        role: '',
        cpf: '',
        username: '',
        label: '',
      },
    }
  },
  computed: {
    ...mapGetters(['profile', 'teamList', 'loadingStatus', 'actualMember'])
  },
  watch: {
    actualMember(member) {
      this.memberData = member
    }
  },
  mounted() {
    this.getOperatorInfo(this.profile.id_operator);
    this.memberData = this.actualMember
  },
  methods: {
    ...mapActions(['getOperatorInfo']),
    formatDate(date) {
      const dateObj = Moment(date, [Moment.ISO_8601, 'DD/MM/YYYY'], true)
      return dateObj.isValid() ? dateObj.format('DD/MM/YYYY') : ''
    },
  },
}
</script>

<style lang="scss">
.account-tab {
	background-color: #fff;
	border: 4px #fff solid;
	border-radius: 6px;
	padding: 6px;

	&__box-wrapper {
		display: flex;
		flex-direction: column;
	}

	&__content-wrapper {
		display: flex;
		flex-direction: column;
		margin-bottom: 16px;
	}

	&__content-wrapper-error {
		display: flex;
		flex-direction: column;
		margin-bottom: 16px;
		justify-content: center;
		align-items: center;
	}
}
</style>